import { TrackingContext as UiTrackingContext } from '@lingoda/analytics';

/**
 * @deprecated Use `ETrackingContext` from `@lingoda/analytics` instead.
 */
export const TrackingContext = UiTrackingContext;
